import { Matrix2D } from '@play-co/timestep-core/math';
import { RenderContext } from '@play-co/timestep-core/renderer';
import { MovieClip } from '@play-co/timestep-core/ui';

/**
 * Adds more functionality to the MovieClip class.
 *  - Adds a `reverse` property to play the animation backwards.
 * @extends MovieClip
 */
export class ExtendedMovieClip extends MovieClip {
  public reverse = false;

  public render(ctx: RenderContext, transform: Matrix2D): void {
    if (!this.animation) {
      return;
    }
    const frameToRender = this.reverse
      ? this.frameCount - 1 - this.frame
      : this.frame;
    this._transform.copy(transform);
    this.animation._wrapRender(
      ctx,
      this._transform,
      ctx.globalAlpha,
      frameToRender,
      this.framesElapsed,
      this._substitutes,
    );
  }
}
